import { Axios } from '@/services';

export const fetchConstants = async () => {
  return (
    await Axios.Api.common('constants', {
      method: 'GET'
    })
  ).data;
};

export const fetchRhapsodyConstants = async () => {
  return (
    await Axios.Api.common('constants/rhapsody', {
      method: 'GET'
    })
  ).data;
};

export const updateConstant = async (constantId, updateDto) => {
  return (
    await Axios.Api.common(`constants/feature-toggle/${constantId}`, {
      method: 'PUT',
      data: updateDto
    })
  ).data;
};
